// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';
import { ReferencesQuery, CombinedState } from 'reducers';
import ReferencesPageComponent from 'components/references-page/references-page';

interface StateToProps {
    fetching: boolean;
    query: ReferencesQuery;
    count: number;
    importing: boolean;
}

function mapStateToProps(state: CombinedState): StateToProps {
    const { references } = state;

    return {
        fetching: state.references.fetching,
        query: references.gettingQuery,
        count: state.references.count,
        importing: state.import.references.backup.importing,
    };
}

export default connect(mapStateToProps)(ReferencesPageComponent);
